import React from "react"
import styles from './footer.module.css'
export default function Footer() {
  return <footer className={styles.footerContainer}>
    <a href="https://github.com/AjayDoddapaneni" target="__blank" className={styles.footerText}>Github</a>
    <a href="https://www.linkedin.com/in/ajay-doddapaneni/" target="__blank" className={styles.footerText}>LinkedIn</a>
    <div className={styles.footerText}>Last Updated May, 2019</div>
</footer>
}